// extracted by mini-css-extract-plugin
export default {"contentbox":"AddTracking_contentbox__3cF8A","orderid":"AddTracking_orderid__GjQ+Q","btn_start":"AddTracking_btn_start__m7VTg","animate-rotate":"AddTracking_animate-rotate__VCA48"};